import { IValidator, IValidations, ICoupon } from '@/interfaces';

export class CouponValidator implements IValidator<ICoupon> {
  public isValid(item: ICoupon) {
    const errors: IValidations<ICoupon> = {};
    if (item.code.length === 0) errors.code = ['Code is Required'];
    if (item.name.length === 0) errors.name = ['Name is Required'];
    if (item.number <= 0) errors.number = ['Number must be greater than zero'];

    return Object.keys(errors).length > 0 ? errors : true;
  }
}